var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"sidebar"},[_c('ul',_vm._l((_vm.menuItems),function(item,index){return _c('li',{key:index},[_c('router-link',{attrs:{"to":item.path}},[_vm._v(_vm._s(item.title))])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }